'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuill = _interopRequireDefault(require("react-quill"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class TextEditor extends _react.PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = value => {
    const component = this,
      props = this.props;

    // useless handleChange triggered by props state reset
    if (!props.value && value === '<p><br></p>') return;
    props.onChange({
      e: null,
      value: value,
      name: props.name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    const status = props.status[props.name] || {};
    const info = status.info ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg c-field-msg--green"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg__content"
    }, status.info)) : undefined;
    const error = status.error ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg c-field-msg--red"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg__content"
    }, status.error)) : undefined;
    const warning = status.warning ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg c-field-msg--orange"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-field-msg__content"
    }, status.warning)) : undefined;
    let modules = {
      toolbar: [[{
        'header': [1, 2, false]
      }], [{
        align: ['justify', 'center', 'right']
      }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
        'list': 'ordered'
      }, {
        'list': 'bullet'
      }, {
        'indent': '-1'
      }, {
        'indent': '+1'
      }], ['link'], ['clean']]
    };
    if (props['without-headings']) {
      modules.toolbar.shift();
    }
    let formats = ['header', 'align', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'left', 'center', 'right', 'justify'];
    if (props.images) {
      formats.push('image');
      modules.toolbar[3].push('image');
    }
    if (props.wsiwg === false) {
      modules.toolbar = false;
    }
    const label = props.label ? /*#__PURE__*/_react.default.createElement("div", {
      className: "form-custom-label"
    }, props.label) : undefined;
    const output = /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width"
    }, label, error, warning, info, /*#__PURE__*/_react.default.createElement(_reactQuill.default, {
      value: props.value,
      formats: formats,
      onChange: component.handleChange,
      modules: modules,
      readOnly: props['read-only']
    }));
    return output;
  }
}
exports.default = TextEditor;
